import {
  type Dispatch,
  type MutableRefObject,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useRef,
  useState,
} from 'react';

import type { TFunction } from 'i18next';
import type { SWRInfiniteResponse } from 'swr/infinite';

import type { Paginate } from '@quick/go-api-types/common';
import type { NotificationGet } from '@quick/go-api-types/notifications';

type tFunc = TFunction<['common', 'OpPl']>;

// TODO: Remove when SWR exports type
type mutator = SWRInfiniteResponse<Paginate<NotificationGet>>['mutate'];

type ContextType = {
  mutateRef: MutableRefObject<mutator | undefined>;
  status: [0 | 1 | 2, Dispatch<SetStateAction<0 | 1 | 2>>];
  t: tFunc;
};

const Context = createContext<ContextType | undefined>(undefined);

export function NotificationsProvider({
  children,
  t,
}: PropsWithChildren<{
  t: tFunc;
}>) {
  const mutateRef = useRef<mutator>();
  const status = useState<0 | 1 | 2>(0); // Conecting | Open | closed
  return (
    <Context.Provider value={{ mutateRef, status, t }}>
      {children}
    </Context.Provider>
  );
}

export function useNotificationsContext() {
  const v = useContext(Context);
  if (v === undefined) throw new Error('Use inside a Notifications Provider');
  return v;
}
